import Messages from './Messages';

export function getDataSuperior() {
  const messages = Messages();
  const data = [
    {
      text: messages.history_parameters_superior_date,
      name: 'date',
    },
    {
      text: messages.history_parameters_superior_time,
      name: 'time',
    },
    {
      text: messages.history_parameters_superior_language,
      name: 'language',
    },
    {
      text: messages.history_parameters_superior_device_type,
      name: 'device_type',
    },
    {
      text: messages.history_parameters_superior_auto_degass_start_1_enable,
      name: 'auto_degass_start_1_enable',
    },
    {
      text: messages.history_parameters_superior_auto_degass_start_1_hour,
      name: 'auto_degass_start_1_hour',
    },
    {
      text: messages.history_parameters_superior_auto_degass_start_1_minute,
      name: 'auto_degass_start_1_minute',
    },
    {
      text: messages.history_parameters_superior_auto_degass_stop_1_enable,
      name: 'auto_degass_stop_1_enable',
    },
    {
      text: messages.history_parameters_superior_auto_degass_stop_1_hour,
      name: 'auto_degass_stop_1_hour',
    },
    {
      text: messages.history_parameters_superior_auto_degass_stop_1_minute,
      name: 'auto_degass_stop_1_minute',
    },

    {
      text: messages.history_parameters_superior_auto_degass_start_2_enable,
      name: 'auto_degass_start_2_enable',
    },
    {
      text: messages.history_parameters_superior_auto_degass_start_2_hour,
      name: 'auto_degass_start_2_hour',
    },
    {
      text: messages.history_parameters_superior_auto_degass_start_2_minute,
      name: 'auto_degass_start_2_minute',
    },
    {
      text: messages.history_parameters_superior_auto_degass_stop_2_enable,
      name: 'auto_degass_stop_2_enable',
    },
    {
      text: messages.history_parameters_superior_auto_degass_stop_2_hour,
      name: 'auto_degass_stop_2_hour',
    },
    {
      text: messages.history_parameters_superior_auto_degass_stop_2_minute,
      name: 'auto_degass_stop_2_minute',
    },
    {
      text: messages.history_parameters_superior_degass_block,
      name: 'degass_block',
    }
  ];
  return data;
}

export function getDataSoftener() {
  const messages = Messages();
  const data = [
    {
      text: messages.history_parameters_date,
      name: 'date',
    },
    {
      text: messages.history_parameters_time,
      name: 'time',
    },
    {
      text: messages.history_parameters_language,
      name: 'language',
    },
    {
      text: messages.history_parameters_unit_water_hardness,
      name: 'unit_water_hardness',
    },

    {
      text: messages.history_parameters_water_pressure,
      name: 'water_pressure',
    },
    {
      text: messages.history_parameters_pressure_sensor,
      name: 'pressure_sensor',
    },
    {
      text: messages.history_parameters_chlorine_generator,
      name: 'chlorine_generator',
    },
    {
      text: messages.history_parameters_reserve_period,
      name: 'reserve_period',
    },
    {
      text: messages.history_parameters_reg_period,
      name: 'reg_period',
    },
    {
      text: messages.history_parameters_days_of_regeneration,
      name: 'days_of_regeneration',
    },

    {
      text: messages.history_parameters_outlet_water_hardness,
      name: 'outlet_water_hardness',
    },
    {
      text: messages.history_parameters_intlet_water_hardness,
      name: 'intlet_water_hardness',
    },
    {
      text: messages.history_parameters_regenerant_dose,
      name: 'regenerant_dose',
    },
    {
      text: messages.history_parameters_resin_volume,
      name: 'resin_volume',
    },
    {
      text: messages.history_parameters_reserve_type,
      name: 'reserve_type',
    },
    {
      text: messages.history_parameters_percentage_of_reserve,
      name: 'percentage_of_reserve',
    },
    {
      text: messages.history_parameters_regeneration_time,
      name: 'regeneration_time',
    },
    {
      text: messages.history_parameters_average_water_used,
      name: 'average_water_used',
    },
    {
      text: messages.history_parameters_ferrum_content,
      name: 'ferrum_content',
    },
    {
      text: messages.history_parameters_type_of_regeneration,
      name: 'type_of_regeneration',
    },
    {
      text: messages.history_parameters_cancel_vacation_mode,
      name: 'cancel_vacation_mode',
    },
    {
      text: messages.history_parameters_backwash,
      name: 'backwash',
    },
    {
      text: messages.history_parameters_rapid_rinsing,
      name: 'rapid_rinsing',
    },
    {
      text: messages.history_parameters_dhcp_client,
      name: 'dhcp_client',
    },
    {
      text: messages.history_parameters_ip_address,
      name: 'ip_address',
    },
    {
      text: messages.history_parameters_subnet_mask,
      name: 'subnet_mask',
    },
    {
      text: messages.history_parameters_default_gateway,
      name: 'default_gateway',
    },
    {
      text: messages.history_parameters_dns_server,
      name: 'dns_server',
    },
    {
      text: messages.history_parameters_timezone,
      name: 'timezone',
    },
    {
      text: messages.history_parameters_device_type,
      name: 'device_type',
    },
  ];
  return data;
}



// WEBPACK FOOTER //
// ./src/components/HistoryParameters/HistoryMessages.js